import { useRef, useState } from 'react'
import './ContactPage.css'

const API = process.env.REACT_APP_API_URL || "";

const COLLAB_AREAS = [
    { value: '', label: 'Select area of collaboration...' },
    { value: 'tech-integration', label: 'Technology Integration' },
    { value: 'research', label: 'Research & Development' },
    { value: 'product-dev', label: 'Product Development' },
    { value: 'other', label: 'Other' },
]

const FIELDS = [
    { id: 'name', label: 'Full Name', type: 'text', span: 1 },
    { id: 'phone', label: 'Phone Number', type: 'tel', span: 1 },
    { id: 'email', label: 'Email Address', type: 'email', span: 2 },
    { id: 'company', label: 'Company / Organisation', type: 'text', span: 1 },
    { id: 'website', label: 'Website (Optional)', type: 'text', span: 1 },
    { id: 'collabArea', label: 'Area of Collaboration', type: 'select', options: COLLAB_AREAS, span: 2 },
    { id: 'message', label: 'Your Proposal', type: 'area', placeholder: 'Describe how you want to collaborate...', span: 2 },
]

export default function PartnerPage() {
    const formRef = useRef(null)
    const [focused, setFocused] = useState(null)
    const [values, setValues] = useState({})
    const [fieldErrors, setFieldErrors] = useState({})
    const [generalError, setGeneralError] = useState(null)
    const [sent, setSent] = useState(false)
    const [submitting, setSubmitting] = useState(false)

    const handleChange = (id, val) => {
        setValues(p => ({ ...p, [id]: val }))
        if (fieldErrors[id]) setFieldErrors(p => { const n = { ...p }; delete n[id]; return n })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setSubmitting(true)
        setGeneralError(null)
        try {
            const res = await fetch(`${API}/api/partners`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(values),
            })
            const data = await res.json()
            if (!res.ok) {
                if (data.errors) setFieldErrors(data.errors)
                else setGeneralError(data.message || 'Submission failed.')
                return
            }
            setSent(true)
            setValues({})
        } catch {
            setGeneralError('Connection error. Please try again.')
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <div className="cp-wrap">
            <div className="cp-hero">
                <div className="cp-hero-grid" />
                <div className="cp-hero-inner">
                    <div className="cp-hero-eyebrow">
                        <span className="cp-hero-dot" style={{ background: '#5d179e' }} />
                        AVIATRICKS · PARTNER WITH US
                    </div>
                    <h1 className="cp-hero-title">
                        Partner<br />
                        <em style={{ WebkitTextStrokeColor: '#5d179e' }}>With Us.</em>
                    </h1>
                    <p className="cp-hero-sub">
                        We collaborate with innovative companies and startups to build
                        the future of drone technology. Tell us about your idea and let's explore it together.
                    </p>
                </div>
            </div>

            <div className="cp-body">
                <div className="cp-info">
                    <div className="cp-info-label">Collaboration Areas</div>
                    <div className="cp-info-items">
                        {['Tech Integration', 'R&D', 'Product Development', 'Data Services', 'AI / ML'].map(item => (
                            <div key={item} className="cp-info-item">
                                <span className="cp-info-item-val">→ {item}</span>
                            </div>
                        ))}
                        <div className="cp-info-item">
                            <span className="cp-info-item-label">Response Time</span>
                            <span className="cp-info-item-val">3 – 5 business days</span>
                        </div>
                        <div className="cp-info-item">
                            <span className="cp-info-item-label">Email</span>
                            <span className="cp-info-item-val">support@aviatricks.in</span>
                        </div>
                    </div>
                </div>

                <div>
                    {!sent ? (
                        <form ref={formRef} className="cp-form" onSubmit={handleSubmit} noValidate>
                            {generalError && <div className="cp-general-error">{generalError}</div>}
                            <div className="cp-grid">
                                {FIELDS.map(f => (
                                    <div key={f.id}
                                        className={`cp-field cp-field--span${f.span} ${focused === f.id || values[f.id] ? 'cp-field--active' : ''}`}
                                    >
                                        <label className="cp-label" htmlFor={f.id}>{f.label}</label>
                                        {f.type === 'area' ? (
                                            <textarea id={f.id} rows={4} className="cp-input" placeholder={f.placeholder}
                                                value={values[f.id] || ''} onFocus={() => setFocused(f.id)} onBlur={() => setFocused(null)}
                                                onChange={e => handleChange(f.id, e.target.value)} />
                                        ) : f.type === 'select' ? (
                                            <select id={f.id} className="cp-select"
                                                value={values[f.id] || ''} onFocus={() => setFocused(f.id)} onBlur={() => setFocused(null)}
                                                onChange={e => handleChange(f.id, e.target.value)}>
                                                {f.options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                                            </select>
                                        ) : (
                                            <input id={f.id} type={f.type} className="cp-input" placeholder={f.placeholder}
                                                value={values[f.id] || ''} onFocus={() => setFocused(f.id)} onBlur={() => setFocused(null)}
                                                onChange={e => handleChange(f.id, e.target.value)} />
                                        )}
                                        {fieldErrors[f.id] && <span className="cp-field-error">{fieldErrors[f.id]}</span>}
                                        <div className="cp-field-line" />
                                    </div>
                                ))}
                            </div>
                            <button type="submit" className="cp-submit" disabled={submitting}>
                                <span>{submitting ? 'Submitting...' : 'Send Proposal'}</span>
                                {!submitting && <span className="cp-submit-arrow">→</span>}
                            </button>
                        </form>
                    ) : (
                        <div className="cp-success">
                            <div className="cp-success-icon">✓</div>
                            <h3>Proposal Sent.</h3>
                            <p>Check your inbox — we've sent a confirmation email.</p>
                            <p>Our team will review your proposal and reach out soon.</p>
                            <button onClick={() => setSent(false)} className="cp-retry">Submit Another</button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}